import { authenticatedAPI } from '../AuthenticatedAPI';
import { z } from 'zod';
import { ExportNewsletterReqDto, ExportParticipantsReqDto } from '@web/common';

export const exportOnboardingData = async (cohortId: string) => {
  return authenticatedAPI.get(`/api/export/onboarding/${cohortId}`, z.any());
};

export const clusteringData = async (cohortId: string) => {
  return authenticatedAPI.get(`/api/export/clustering/${cohortId}`, z.any());
};

export const studyData = async (cohortId: string) => {
  return authenticatedAPI.get(`/api/export/study-data/${cohortId}`, z.any());
};

export const newsletterEmails = async (body: ExportNewsletterReqDto) => {
  return authenticatedAPI.post(`/api/export/newsletter-emails`, body, z.any());
};

export const exportParticipants = async (body: ExportParticipantsReqDto) => {
  const csv = await authenticatedAPI.post(
    `/api/export/participants`,
    body,
    z.any(),
  );
  // Excel needs a UTF-8 BOM at the start of the file to show umlauts
  // correctly. The backend cannot add it: the browser removes a leading
  // BOM when it decodes the response into a string, before axios reads it.
  // Add the BOM here instead, right before the code makes the file.
  // Use fromCharCode, not a literal BOM character, to keep the raw byte
  // out of the source file.
  return String.fromCharCode(0xfeff) + csv;
};

/*
 * note, that If they say: "Phone-tracking für Kohorte 5 - 2.1" that means for us "Kohorte 5, horizon = 1, wave = 1"
 */
export const phoneTrackingData = async (
  cohortId: string,
  horizon: number,
  wave: number,
) => {
  return authenticatedAPI.get(
    `/api/export/phone-tracking/${cohortId}/${horizon}/${wave}`,
    z.any(),
  );
};
